import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function historicalPlacesRoutes($stateProvider: StateProvider) {
    let historicalPlacesModule: { default: any; };
    $stateProvider
        .state({
            name: 'places-history',
            url: '/places-history',
            component: KpSvelteComponentWrapperComponent.componentName,
            resolve: {
                component: () => historicalPlacesModule.default,
            },
            lazyLoad: async () => {
                historicalPlacesModule = await import(/* webpackChunkName: "historicalPlaces" */ './KpHistoricalPlaces.svelte');
                return null;
            }
        });
}